import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { productListService } from './AssociateDocument.services';
import Multiselect from 'vue-multiselect'


@Component({
    components:{
        Multiselect
    }
})
export default class AssociateDocument extends Vue{
    public data1: any = [];
    public postResponseData: any;
    public newData: any[] = [];
    public fullPage: boolean = false;
    public file: any;
    public submitted: boolean = false;
    public errorMessage: string = '';
    public successMessage: string ='';
    public selected: any[] = [];
    public options:any = [];
    public merror:string = '';
    public buttonDisabled:boolean =false;
    public $loading: any;
    public selectAll: boolean = false;
    constructor(){
        super();
    }

    public data(){
        return{
            submitted: false,
            errorMessage: '',
            successMessage:'',
            selected: [],
            options: [],
            buttonDisabled:false,
            selectAll: false
        }
    }

    getLoginToken():void{
        console.log(this.$store.state.username);
        return this.$store.getters.getLoginToken;
    }
    
    mounted(): void{
        this.data1 = this.getLoginToken();
        console.log(this.data1);
        console.log("Associate Document mounted successfully");
        this.productListing();

    }

    public async productListing(): Promise<void>{
        this.buttonDisabled = true;
        let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            // onCancel: this.onCancel,
          });
        
        let token = localStorage.getItem("token");
        // let token = this.$store.getters.getLoginToken.token;

        const res = productListService.GetproductList(token).
        then((response:any) =>{
            this.data1 = response.data['data']['product_list'];
            let list = this.data1;
            this.buttonDisabled = false;
            for(var i = 0; i < list.length; i++) {
                var obj = list[i];
                // console.log(obj.name);
                this.options.push(obj.name);
                // console.log(obj.id);
            }
            loader.hide();
        }).catch((error: any) =>{
            console.log(error.response);
            loader.hide();
        });
    }

    submitDocument():void{
        let form = <any>document.getElementById("form") as HTMLFormElement;
        let formData = new FormData(form);
        console.log('selected');
        console.log(this.selected);
        this.buttonDisabled = true;
        let stringList = "";
        this.selected.forEach((value,index)=>{
            if (index !== 0){
            stringList = stringList + "|" + value;
            }else{
                stringList = stringList + value;
            }
        });
        
        formData.append('document_file', this.file);
        formData.append('product_list', stringList);
        this.submitted = true;
        // console.log('selected - ',this.selected);
        console.log('length - ', this.selected.length)
        // debugger
        if(this.selected.length  === 0){
            this.merror = "The Product Name field is required";
        }
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.postDocument(formData);
                    // this.buttonDisabled = false;
                }else{
                    this.buttonDisabled = false;
                }
            });
    }

    clearSEMessage(){
        console.log('clearse');
        console.log(this.options.length);
        console.log(this.selected.length);
        if(this.selected.length > 0){
            if(this.selected[0] === '')
            {
                this.merror = "The Product Name field is required";    
            }else{
                this.merror = '';  
                this.selectAll = false;  
            }
            // console.log('!=', this.selected);

        }else if(this.selected.length === 0){
            this.merror = "The Product Name field is required";
            // console.log('==', this.selected);
        }
        if (this.selected.length === this.options.length){
            this.selectAll = true;
        }
        
        this.errorMessage = '';
        this.successMessage = '';
    }

    handleFileUpload(){
        this.file = document.getElementById('document') as HTMLElement;
        this.file = this.file.files[0];
        // this.file = this.$refs.file.files[0];
        this.successMessage = '';
        this.errorMessage = '';
        console.log()
        console.log(this.file);
    }

    public async postDocument(formData:any): Promise<void>{
        let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            // onCancel: this.onCancel,
          });
        
        // let token = this.$store.getters.getLoginToken.token;
        let token = localStorage.getItem("token");

        const res = productListService.postDocument(formData,token).
        then((response:any) =>{
            if(this.errorMessage !== ''){
                this.errorMessage = '';
            }
            
            this.buttonDisabled = false;
            this.successMessage = 'Document uploaded successfully !';
            this.postResponseData = response.data['data'];
            console.log(this.postResponseData);
            this.selected = [];
            this.selectAll = false;
            loader.hide();
            let form = document.getElementById("form") as HTMLFormElement;
            form.reset();
            this.newData = [];
            this.$validator.reset();
        }).catch((error: any) =>{
            loader.hide();
            this.buttonDisabled = false;
            if(error.response.data['data']['message']){
            this.errorMessage = error.response.data['data']['message'];
            }
            console.log("line number");
            if(error.response.data['data']['errors']['document_name'][0]){
                this.errorMessage = 'Document name is already taken. Try another one.';
            }

        });
    }

    @Watch('selectAll')
    onCheckAllChanged(value: string, oldValue: string){
        if(this.selectAll) {
        this.selected = this.options;
        this.merror = '';
        } else if(this.selectAll === false && this.selected.length === this.options.length){
            this.selected = [];
            this.merror = "The Product Name field is required";
        } else if(this.selectAll === false){
        }
    }
}